import { useEffect } from "react";

/**
 * Hook that invokes the handler function if clicked outside the ref element
 * @param {React.RefObject<HTMLElement>} ref - the reference to the element
 * @param {Function} handler
 */
const useClickOutside = (ref, handler) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                handler();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [ref, handler]);
};

export default useClickOutside;
